/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface EmailSettingsEditDto
 */
export interface EmailSettingsEditDto {
    /**
     * 
     * @type {string}
     * @memberof EmailSettingsEditDto
     */
    defaultFromAddress: string;
    /**
     * 
     * @type {string}
     * @memberof EmailSettingsEditDto
     */
    defaultFromDisplayName: string;
    /**
     * 
     * @type {string}
     * @memberof EmailSettingsEditDto
     */
    smtpHost: string;
    /**
     * 
     * @type {number}
     * @memberof EmailSettingsEditDto
     */
    smtpPort: number;
    /**
     * 
     * @type {string}
     * @memberof EmailSettingsEditDto
     */
    smtpUserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailSettingsEditDto
     */
    smtpPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailSettingsEditDto
     */
    smtpDomain?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EmailSettingsEditDto
     */
    smtpEnableSsl?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EmailSettingsEditDto
     */
    $type?: EmailSettingsEditDtoTypeEnum;
}


/**
 * @export
 */
export const EmailSettingsEditDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedConfigurationDtoEmailSettingsEditDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Configuration.Dto.EmailSettingsEditDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EmailSettingsEditDtoTypeEnum = typeof EmailSettingsEditDtoTypeEnum[keyof typeof EmailSettingsEditDtoTypeEnum];


/**
 * Check if a given object implements the EmailSettingsEditDto interface.
 */
export function instanceOfEmailSettingsEditDto(value?: unknown): value is EmailSettingsEditDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EmailSettingsEditDtoTypeEnum)[0];
}

export function EmailSettingsEditDtoFromJSON(json: any): EmailSettingsEditDto {
    return EmailSettingsEditDtoFromJSONTyped(json, false);
}

export function EmailSettingsEditDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailSettingsEditDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'defaultFromAddress': json['defaultFromAddress'],
        'defaultFromDisplayName': json['defaultFromDisplayName'],
        'smtpHost': json['smtpHost'],
        'smtpPort': json['smtpPort'],
        'smtpUserName': !exists(json, 'smtpUserName') ? undefined : json['smtpUserName'],
        'smtpPassword': !exists(json, 'smtpPassword') ? undefined : json['smtpPassword'],
        'smtpDomain': !exists(json, 'smtpDomain') ? undefined : json['smtpDomain'],
        'smtpEnableSsl': !exists(json, 'smtpEnableSsl') ? undefined : json['smtpEnableSsl'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function EmailSettingsEditDtoToJSON(value?: EmailSettingsEditDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'defaultFromAddress': value.defaultFromAddress,
        'defaultFromDisplayName': value.defaultFromDisplayName,
        'smtpHost': value.smtpHost,
        'smtpPort': value.smtpPort,
        'smtpUserName': value.smtpUserName,
        'smtpPassword': value.smtpPassword,
        'smtpDomain': value.smtpDomain,
        'smtpEnableSsl': value.smtpEnableSsl,
        '$type': value.$type,
    });
}

